import React from "react";
import {
  Box,
  Typography,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import Image from "./images/3daestheticsshape2.png";

const AudienceSection = () => {
  return (
    <Box
      sx={{
        background: {
          xs: `url(${Image}) center bottom no-repeat`,
          md: `url(${Image}) center bottom no-repeat`,
        },
        backgroundSize: { xs: "100%", md: "30%" },
        backgroundPosition: { xs: "center bottom", md: "right" },
        color: "#000",
        py: { xs: 5, md: 8 },
        px: { xs: 3, md: 6 },
        textAlign: "center",
        position: "relative",
        minHeight: { xs: "auto", md: "80vh" },
        display: "flex",
        flexDirection: "column",
        justifyContent: { xs: "flex-start", md: "center" },
        alignItems: { xs: "stretch", md: "center" },
      }}
    >
      <Box
        sx={{
          maxWidth: "900px",
          mx: "auto",
          mb: { xs: 1, md: 8 },
        }}
      >
        <Typography
          variant="h4"
          fontWeight="bold"
          sx={{
            mb: 3,
            lineHeight: 1.3,
            fontSize: {
              xs: "2.1rem",
              md: "3.3rem",
            },
          }}
        >
          Моя программа идеально подходит для тех, кто:
        </Typography>
      </Box>
      <Grid
        container
        spacing={4}
        sx={{
          width: "100%",
          maxWidth: "900px",
          justifyContent: { xs: "flex-start", md: "center" },
        }}
      >
        <Grid
          item
          xs={12}
          md={8}
          sx={{
            backgroundColor: {
              xs: "rgba(255, 255, 255, 0.9)",
              md: "transparent",
            },
            p: { xs: 2, md: 0 },
            borderRadius: { xs: "10px", md: "0" },
          }}
        >
          <List>
            <ListItem>
              <ListItemIcon>
                <ThumbUpAltIcon sx={{ color: "#7904a3" }} />
              </ListItemIcon>
              <ListItemText primary="Хочет больше уверенности, энергии и баланса." />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <ThumbUpAltIcon sx={{ color: "#7904a3" }} />
              </ListItemIcon>
              <ListItemText primary="Стремится к успеху в бизнесе или карьере." />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <ThumbUpAltIcon sx={{ color: "#7904a3" }} />
              </ListItemIcon>
              <ListItemText primary="Чувствует, что застрял в рутине и ищет вдохновение для нового старта." />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <ThumbUpAltIcon sx={{ color: "#7904a3" }} />
              </ListItemIcon>
              <ListItemText primary="Ищет поддержку и ясность в принятии сложных решений." />
            </ListItem>
            <ListItem>
              <ListItemIcon>
                <ThumbUpAltIcon sx={{ color: "#7904a3" }} />
              </ListItemIcon>
              <ListItemText primary="Стремится развить лидерские навыки и выстроить сильную команду." />
            </ListItem>
          </List>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AudienceSection;
